import React, { useEffect } from 'react';
import PropTypes from 'prop-types';
import { useSelector } from 'react-redux';
import CookieConsent, { Cookies } from 'react-cookie-consent';

import { LinkWithPreload } from 'components/shared/PreloadableLinks';

import container from 'containers/CookieBannerModalContainer';

import { PRIVACY_POLICY, TERMS_AND_CONDITIONS } from 'utils/routes';

export const CookieBannerModal = ({ setIsBannerVisible }) => {
  const cookieName = 'sg-consent-cookie';
  const isWebView = useSelector(({ app }) => app?.isWebView);

  useEffect(() => {
    const isBannerVisible = Cookies.get(cookieName) === undefined;

    setIsBannerVisible(isBannerVisible);
  }, [setIsBannerVisible]);

  if (isWebView) return null;

  return (
    <CookieConsent
      buttonId="cookie-consent"
      disableStyles
      containerClasses="z-100 fixed w-full border-t border-grey-4 md:border-none md:w-88 md:left-8 md:!bottom-8 md:shadow-cookies-modal bg-white md:rounded-4 p-6 flex flex-col justify-between"
      buttonClasses="w-full bg-primary block text-white h-10 rounded-2 text-3.5 focus:outline-none"
      buttonText="Got It!"
      cookieName={cookieName}
      onAccept={() => setIsBannerVisible(false)}

    >
      <p className="mb-3 font-bold text-dark-grey">This Site Uses Cookies</p>
      <p className="mb-2 text-3 text-dark-grey">
        We use cookies to enhance your experience with
        {' '}
        {process.env.REACT_APP_FRIENDLY_NAME}
        .
        By clicking below or continuing to browse you consent to our
        <LinkWithPreload to={PRIVACY_POLICY} className="text-primary"> use of cookies.</LinkWithPreload>
      </p>

      <p className="mb-4 text-3 text-dark-grey">
        {`By continuing, you agree to ${process.env.REACT_APP_FRIENDLY_NAME}'s `}
        <LinkWithPreload to={PRIVACY_POLICY} className="font-bold text-primary">
          privacy policy
        </LinkWithPreload>
        {', '}
        <LinkWithPreload to={PRIVACY_POLICY} className="font-bold text-primary">
          cookies policy
        </LinkWithPreload>
        {' and '}
        <LinkWithPreload to={TERMS_AND_CONDITIONS} className="font-bold text-primary">
          conditions of use
        </LinkWithPreload>
        .
      </p>
    </CookieConsent>
  );
};

CookieBannerModal.propTypes = {
  setIsBannerVisible: PropTypes.func.isRequired,
};

export default container(CookieBannerModal);
